import { TitleCasePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { AnalyticsService, LoggerService, PartnerBrandService, PolicyService } from '@campfire-nx/api';
import { PortalRedirectService } from '@open-portal-app/core/services/portal-redirect.service';


@Component({
  selector: 'app-auto-renewal',
  templateUrl: './auto-renewal.component.html',
  styleUrls: ['./auto-renewal.component.scss']
})
export class AutoRenewalComponent implements OnChanges {
  @Input() policyDetails!: any;
  @Output() updatePolicyDetails = new EventEmitter<any>(false);
  autoRenew!: boolean;
  isAutoRenewUpdating = false;
  showToggleError = false;

  constructor(
    private loggerService: LoggerService,
    private analyticsService: AnalyticsService,
    private policyService: PolicyService,
    private portalRedirectService: PortalRedirectService,
    private partnerBrandService: PartnerBrandService,
    private titleCasePipe: TitleCasePipe
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.autoRenew = this.policyDetails.autoRenew;
  }

  toggleAutoRenew() {
    this.isAutoRenewUpdating = true;
    const newAutoRenewValue = !this.autoRenew;
    const renewalFlag = newAutoRenewValue ? 'CE' : 'CD';
    const eventCategory = `${this.titleCasePipe.transform(this.policyDetails.productClass)} Policy`;

    this.policyService.updateRenewalFlag(this.policyDetails.slug, renewalFlag)
      .then(() => {
        this.updatePolicyDetails.emit();

        // wait a bit before allowing user to edit again
        setTimeout(() => {
          this.autoRenew = newAutoRenewValue;
          this.isAutoRenewUpdating = false;
        }, 1000)

        this.analyticsService.trackEvent(
          eventCategory,
          'Auto renewal changed',
          'Success',
          {
            policy: this.policyDetails.slug,
            renewalFlag,
            userSlug: this.policyDetails.userSlug
          }
        );
        this.loggerService.info('AutoRenewalComponent', 'toggleAutoRenew', {
          policy: this.policyDetails.slug,
          renewalFlag,
        });
      })
      .catch(err => {
        this.showToggleError = true;
        this.isAutoRenewUpdating = false;

        this.analyticsService.trackEvent(eventCategory, 'Auto renewal changed', 'Failure',
          {
            policy: this.policyDetails.slug,
            renewalFlag,
            userSlug: this.policyDetails.userSlug
          }
        );
        this.loggerService.error('AutoRenewalComponent', 'toggleAutoRenew', {
          error: err,
          policy: this.policyDetails.slug,
          renewalFlag,
        });
      })
  }

  bookAppointment() {
    const topic = 'renewals';
    const payload = {
      source: 'opv2-policy',
      partner_slug: this.partnerBrandService.getAttribute('slug', 'partner'),
      option: 'renewal_endorsement',
      entity: 'toggle-autorenew',
      entity_ref: this.policyDetails.slug,
      topic
    }

    this.portalRedirectService.bookAppointment(topic, payload);
    this.loggerService.info('AutoRenewalComponent', 'bookAppointment', { policy: this.policyDetails.slug }, 'toggle-renewal-help');
  }

}
